import * as cx from 'classnames';
import { History } from 'history';
import {
    BZ2_GO_BOTTOM,
    BZ2_GO_NEXT,
    BZ2_GO_PREVIOUS,
    BZ2_GO_TOP,
    CANCEL,
    GO_PAGING,
    OUT_OF,
    PAGE,
} from 'mk/autogenerated/translations/Pager.a4c1c57cc6aa3cc6ff81c761312ab775'
import Btn, { BtnLayout, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import Link from 'mk2/components/Link';
import { scrollDocumentTo } from 'mk2/helpers/scrolling';
import { removeEmpty, removePage1 } from 'mk2/helpers/urls';
import { parse, stringify } from 'query-string';
import * as React from 'react';
import styles from './Pager.mscss';

interface OwnProps {
    id?: string;
    className?: string;
    page: number;
    numberOfPages: number;
    history: History;
    position: 'top' | 'bottom';
    isMobile: boolean;
}

interface State {
    page: string;
    showFormControls: boolean;
}

type Props = OwnProps;

const url = (base: string, params: any) => {
    const search = stringify(params);
    return base + (search ? `?${search}` : '');
};

class Pager extends React.Component<Props, State> {

    private inputElem: HTMLInputElement;

    constructor(props: Props) {
        super(props);

        this.state = {
            page: props.page.toString(),
            showFormControls: false,
        };
    }

    public shouldComponentUpdate(n: Props, ns: State) {
        const p = this.props;
        const ps = this.state;

        return n.page !== p.page
            || n.numberOfPages !== p.numberOfPages
            || ns.showFormControls !== ps.showFormControls
            || ns.page !== ps.page;
    }

    public componentWillReceiveProps(nextProps: Props) {
        // Reset state when new page is sent from parent
        if (this.props.page !== nextProps.page) {
            this.setState({
                page: nextProps.page.toString(),
                showFormControls: false,
            });
        }
    }

    public render() {
        const { id, className, numberOfPages, page, history, position, isMobile } = this.props;
        const { location } = history;

        const query = parse(location.search);

        const hasNext = page < numberOfPages;
        const hasPrevious = page > 1;

        const pageForm = (
            <span className={styles.Pager__pageForm}>
                {PAGE}
                {' '}
                <form onSubmit={this.onSubmit}>
                    <input
                        className={styles.Pager__pageForm__input}
                        type="text"
                        name="page"
                        value={this.state.page}
                        onChange={this.onChange}
                        onFocus={this.onFocus}
                        ref={this.handleInputRef}
                    />
                    {this.state.showFormControls && (
                        <span className={styles.Pager__pageForm__controls}>
                            <Btn type={BtnType.Blue} label={GO_PAGING} onClick={this.onSubmit} />
                            <Btn type={BtnType.Link} label={CANCEL} onClick={this.onCancel} />
                        </span>
                    )}
                </form>
                {' '}
                {!this.state.showFormControls ? (
                    <div>
                        {OUT_OF}
                        {page !== numberOfPages ? (
                            <Link
                                className={styles.Pager__pageForm__numberOfPages}
                                to={{
                                    ...location,
                                    search: stringify({
                                        ...query,
                                        page: numberOfPages,
                                        scrollto: 'first',
                                    }),
                                    state: {
                                        ignoreScroll: true,
                                        skipOnBack: true,
                                    },
                                }}
                            >
                                {numberOfPages}
                            </Link>
                        ) : (
                            <span className={styles.Pager__pageForm__numberOfPages}>
                                {numberOfPages}
                            </span>
                        )}
                    </div>
                ) : null}
            </span>
        );

        return (
            <div id={id}>
                {numberOfPages > 1 && (
                    <div className={cx(styles.Pager, className)}>
                        {position === 'top' && (
                            <Btn
                                type={BtnType.BlueTextLight}
                                // fa-fw: chceme trochu viac vzduchu pri icone
                                icon={cx('fa-chevron-down fa-lg', !isMobile && 'fa-fw')}
                                label={!isMobile && BZ2_GO_BOTTOM}
                                onClick={this.onDownScroll}
                                sidePadding={BtnSidePadding.Right}
                                className={styles.Pager__leftBtn}
                            />
                        )}
                        {position === 'bottom' && (
                            <Btn
                                type={BtnType.BlueTextLight}
                                // fa-fw: chceme trochu viac vzduchu pri icone
                                icon={cx('fa-chevron-up fa-lg', !isMobile && 'fa-fw')}
                                label={!isMobile && BZ2_GO_TOP}
                                onClick={this.onUpScroll}
                                sidePadding={BtnSidePadding.Right}
                                className={styles.Pager__leftBtn}
                            />
                        )}

                        <div className={styles.Pager__spring} />

                        {!(isMobile && this.state.showFormControls) && (
                            <Btn
                                type={BtnType.BlueTextLight}
                                // fa-fw: chceme trochu viac vzduchu pri icone
                                icon={cx('fa-chevron-left fa-lg', !isMobile && 'fa-fw')}
                                label={!isMobile && BZ2_GO_PREVIOUS}
                                link={{
                                    pathname: location.pathname,
                                    search: stringify(removeEmpty(removePage1({
                                        ...query,
                                        page: Math.max(page - 1, 1),
                                        // klikam na 'prev', odscroluj ma na prvy prispevok predoslej strany
                                        scrollto: position === 'bottom' ? 'first' : null,
                                    }))),
                                    state: {
                                        ignoreScroll: true,
                                        skipOnBack: true,
                                    },
                                }}
                                linkRel="prev"
                                disabled={!hasPrevious}
                            />
                        )}

                        <div className={styles.Pager__pagingNumbers}>
                            {pageForm}
                        </div>

                        {!(isMobile && this.state.showFormControls) && (
                            <Btn
                                type={BtnType.BlueTextLight}
                                layout={BtnLayout.LabelIcon}
                                // fa-fw: chceme trochu viac vzduchu pri icone
                                icon={cx('fa-chevron-right fa-lg', !isMobile && 'fa-fw')}
                                label={!isMobile && BZ2_GO_NEXT}
                                sidePadding={BtnSidePadding.Left}
                                link={{
                                    pathname: location.pathname,
                                    search: stringify(removeEmpty(removePage1({
                                        ...query,
                                        page: page + 1,
                                        scrollto: position === 'bottom'
                                            // klikam na 'next' v dolnom pageri, odscroluj ma na prvy prispevok,
                                            // ktory je navrchu dalsej stranky
                                            ? 'first'
                                            // klikam na 'next' v hornom pageri, nemen scroll position,
                                            // iba sa dole pod nami prekreslia prispevky
                                            : null,
                                    }))),
                                    state: {
                                        ignoreScroll: true,
                                        skipOnBack: true,
                                    },
                                }}
                                linkRel="next"
                                disabled={!hasNext}
                                className={styles.Pager__rightBtn}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }

    private onSubmit = (ev) => {
        ev.preventDefault();  // treba aby sa na Enter nerobil page-reload

        const { history, numberOfPages, position } = this.props;
        const { location } = history;
        const query = parse(location.search);

        let page = parseFloat(this.state.page);
        if (page < 1) {
            page = 1;
        }
        if (page > numberOfPages) {
            page = numberOfPages;
        }

        // remove focus from input
        this.inputElem.blur();

        if (page === this.props.page) {
            // Ignore if actual page is the same
            this.setState({
                showFormControls: false,
            });
            return;
        }

        history.push(url(location.pathname, removeEmpty(removePage1({
            ...query,
            page,
            scrollto: position === 'bottom' ? 'first' : null,
        }))), {
            ignoreScroll: true,
            skipOnBack: true,
        });
    };

    private onChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            page: event.currentTarget.value,
        });
    };

    private onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        // Select text
        event.currentTarget.select();

        this.setState({
            showFormControls: true,
        });
    };

    private onCancel = () => {
        this.setState({
            showFormControls: false,
            page: this.props.page.toString(),
        });
    };

    private onUpScroll = () => {
        scrollDocumentTo('top', 0, true);
    };

    private onDownScroll = () => {
        scrollDocumentTo('bottom', 0, true);
    };

    private handleInputRef = (ref: HTMLInputElement) => {
        this.inputElem = ref;
    };
}

export default Pager;
